import * as React from 'react';

const CalendarGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <path fill="none" d="M0 0h144v144H0z" />
                <g>
                    <path
                        fill="#FFF"
                        d="M25.5 112.5h93v-66h-93zM25.5 46.5h93v-15h-93z"
                    />
                    <path
                        stroke="#3A3A3A"
                        strokeWidth={3}
                        d="M25.5 112.5h93v-66h-93z"
                    />
                    <path
                        fill="#D2D6DF"
                        d="M55.5 66h9v-9h-9zM67.5 66h9v-9h-9zM79.5 66h9v-9h-9zM91.5 66h9v-9h-9zM103.5 66h9v-9h-9zM31.5 78h9v-9h-9zM43.5 78h9v-9h-9zM55.5 78h9v-9h-9zM67.5 78h9v-9h-9zM79.5 78h9v-9h-9zM91.5 78h9v-9h-9zM103.5 78h9v-9h-9zM31.5 90h9v-9h-9zM43.5 90h9v-9h-9zM55.5 90h9v-9h-9z"
                    />
                    <path
                        fill="#F6682F"
                        d="M67.5 90h9v-9h-9zM79.5 90h9v-9h-9zM91.5 90h9v-9h-9zM103.5 90h9v-9h-9zM31.5 102h9v-9h-9zM43.5 102h9v-9h-9zM55.5 102h9v-9h-9zM67.5 102h9v-9h-9zM79.5 102h9v-9h-9z"
                    />
                    <path
                        stroke="#3A3A3A"
                        strokeWidth={3}
                        d="M25.5 42V31.5h93V42"
                    />
                    <path
                        d="M34.5 37.5h75M49.5 61.5h-3M37.5 61.5h-3M109.5 97.5h-3M97.5 97.5h-3"
                        stroke="#3A3A3A"
                        strokeWidth={3}
                        strokeLinejoin="round"
                    />
                </g>
            </g>
        </g>
    </svg>
);

CalendarGraphicSvg.displayName = 'CalendarGraphicSvg';
export default CalendarGraphicSvg;
